import { Box } from "@mui/material";
import { useRef } from "react";
import { DarkOverlay } from "../darkOverlay/DarkOverlay";
import { WebcamCapture, WebcamCaptureHandle } from "../QrScanner/WebcamCapture";
import { StyledAddImage } from "./AddImage.styled";

type AddImageProps = {
  opened: boolean;
  onClose: () => void;
  onCapture: (imageStr: string) => void;
};

export const AddImage = ({ opened, onClose, onCapture }: AddImageProps) => {
  const camRef = useRef<WebcamCaptureHandle>(null);

  const handleCapture = () => {
    camRef.current?.capture();
  };

  return (
    <DarkOverlay
      opened={opened}
      onClose={onClose}
      component={
        <StyledAddImage>
          <Box className="captureBtn" onClick={handleCapture}>
            <Box className="captureCircle" />
          </Box>

          <Box className="camera">
            <WebcamCapture
              ref={camRef}
              onCapture={(img) => {
                onCapture(img);
              }}
            />
          </Box>
        </StyledAddImage>
      }
    />
  );
};